module.exports = __webpack_public_path__ + "static/media/QLogo2.b79f3a2d.svg";